// extracted by mini-css-extract-plugin
export default {"payments":"gd-z","header":"hd-z","adjustMarginAndPaddingNewDesign":"id-z"};